import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgLinesHorizontalFour = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Four Horizontal Lines",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      fill={color}
      d="M1.021 6.543H30.98a1.021 1.021 0 0 0 0-2.043H1.02a1.021 1.021 0 0 0 0 2.043Z"
    />
    <path
      fill={color}
      d="M30.979 6.543H1.02a1.021 1.021 0 0 1 0-2.043H30.98a1.021 1.021 0 0 1 0 2.043ZM1.021 13.585H30.98a1.022 1.022 0 0 0 0-2.043H1.02a1.021 1.021 0 1 0 0 2.043Z"
    />
    <path
      fill={color}
      d="M30.979 13.585H1.02a1.021 1.021 0 0 1 0-2.043H30.98a1.021 1.021 0 1 1 0 2.043ZM1.021 20.628H30.98a1.022 1.022 0 0 0 0-2.043H1.02a1.021 1.021 0 0 0 0 2.043Z"
    />
    <path
      fill={color}
      d="M30.979 20.628H1.02a1.021 1.021 0 0 1 0-2.043H30.98a1.022 1.022 0 0 1 0 2.043ZM1.021 27.67H30.98a1.022 1.022 0 0 0 0-2.042H1.02a1.021 1.021 0 0 0 0 2.042Z"
    />
    <path
      fill={color}
      d="M30.979 27.67H1.02a1.021 1.021 0 0 1 0-2.042H30.98a1.022 1.022 0 0 1 0 2.042Z"
    />
  </svg>
);

const LinesHorizontalFour = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgLinesHorizontalFour />
  </BaseIcon>
);

export default LinesHorizontalFour;
